import { ToastType } from '@chegg-wt/core-wa/state/types'

export const SUGGESTION_TABS_ID = 'suggestion-tabs-id'
export const SUGGESTION_TABS_ARIA_LABEL = 'suggestion-tabs-aria-label'
export const SUGGESTION_TABS_TEST = 'suggestion-tabs-test'

export const TOAST_ERRORS = [ToastType.CLARITY_ERROR, ToastType.GRAMMAR_ERROR]
